import { render } from "./CusPage.vue?vue&type=template&id=427901e0&scoped=true"
import script from "./CusPage.vue?vue&type=script&lang=js"
export * from "./CusPage.vue?vue&type=script&lang=js"

import "./CusPage.vue?vue&type=style&index=0&id=427901e0&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427901e0"]])

export default __exports__